/**
 * @desc 人员管理列表
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** page */
  page: number;
  /** pageSize */
  pageSize: number;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.Pager<defs.PeopleManageDTO>>> {
  return defHttp.get({
    url: '/web/labour/queryPerson',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.Pager<defs.PeopleManageDTO>>> {
  return defHttp.get({
    url: '/mock/web/labour/queryPerson',

    params,
  });
}
